import { useScrollReveal } from '@/hooks/useScrollReveal';
import { Link } from 'react-router-dom';

export default function AboutPreview() {
  const imageRef = useScrollReveal<HTMLDivElement>(0.12, 'scale');
  const textRef = useScrollReveal<HTMLDivElement>(0.12, 'fade-left');

  return (
    <section className="relative bg-background-50 px-6 md:px-10 lg:px-16 py-24 md:py-32">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <div ref={imageRef} className="lg:col-span-2">
            <div className="relative aspect-[3/4] overflow-hidden img-hover-zoom">
              <img
                src="https://storage.readdy-site.link/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/cde4356a-5aa4-4713-a0b2-7b6d7017098f_compressed_Blue-Suit-2.webp"
                alt="Keaton Brown"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Text */}
          <div ref={textRef} className="lg:col-span-3">
            <div className="inline-flex items-center gap-3 mb-8">
              <span className="w-6 h-[1px] bg-accent-500/40" />
              <span className="text-accent-500/70 text-xs tracking-[0.2em] uppercase font-medium">
                About
              </span>
            </div>

            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight">
              A versatile baritone<br />with a growing presence
            </h2>

            <p className="mt-8 text-foreground-600 leading-relaxed text-base md:text-lg max-w-xl">
              Keaton Brown is emerging as a versatile baritone, establishing an expansive career as an opera,
              musical theatre, oratorio, and teaching artist performer. Recent and upcoming engagements include
              Opera San Jose, Nashville Opera, Opera North (USA), HOPERA, and Houston Grand Opera.
            </p>

            <Link
              to="/about"
              className="inline-flex items-center gap-3 mt-8 group cursor-pointer"
            >
              <span className="text-foreground-800 text-sm tracking-[0.12em] uppercase group-hover:text-accent-500 transition-colors duration-300 whitespace-nowrap">
                Read Full Biography
              </span>
              <span className="w-8 h-8 rounded-full border border-foreground-200 flex items-center justify-center group-hover:border-accent-500 group-hover:scale-110 transition-all duration-300">
                <i className="ri-arrow-right-line text-foreground-700 text-sm group-hover:text-accent-500 group-hover:translate-x-0.5 transition-all duration-300"></i>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}